import { Component, Input } from '@angular/core';
import { IUITKRadioGroupItem } from '@uitk/angular';
import { Dialog } from '../../helpers/dialog';

@Component({
  selector: 'app-isbn-product-select',
  templateUrl: './isbn-product-select.component.html',
  styleUrls: ['./isbn-product-select.component.css']
})
export class IsbnProductSelectComponent {
  @Input() dialog!: Dialog<string | null>;
  @Input() itemList: IUITKRadioGroupItem[] = [];

  selectedProduct: IUITKRadioGroupItem | null = null;

  confirm(): void {
    const selected = this.selectedProduct?.value ?? null;
    this.selectedProduct = null;
    this.dialog.close(selected);
  }

  cancel(): void {
    this.selectedProduct = null;
    this.dialog.close(null);
  }
}